(function () {
  'use strict';
  var root, busy = false, uncertain = false, pendingRefresh = false, feedbackTimer;
  function route(path) { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + path; }
  function contextPath() { return window.location.pathname + window.location.search; }
  async function request(url, options) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
    try { return await fetch(url, Object.assign({credentials: 'same-origin'}, options, {signal: controller.signal})); }
    finally { window.clearTimeout(timeout); }
  }
  function feedback(message, persistent) {
    window.clearTimeout(feedbackTimer);
    var panel = root.querySelector('.zr-builder__feedback');
    if (!panel) return;
    panel.hidden = !message;
    panel.querySelector('[data-zr-builder-status]').textContent = message;
    panel.querySelector('[data-zr-builder-retry]').hidden = !uncertain;
    if (message && !persistent) feedbackTimer = window.setTimeout(function () { panel.hidden = true; }, 5000);
  }
  function controls() {
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
    root.querySelectorAll('[data-zr-builder-write], [data-zr-builder-quantity], [data-zr-builder-variant]').forEach(function (el) { el.disabled = busy || uncertain; });
    root.querySelectorAll('[data-zr-builder-sort], [data-zr-builder-retry]').forEach(function (el) { el.disabled = busy; });
    root.querySelectorAll('a').forEach(function (el) { if (busy) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled'); });
  }
  function syncArtwork(select) {
    var option = select.selectedOptions[0];
    var card = select.closest('[data-zr-builder-card]');
    var image = card.querySelector('.zr-builder-card__art img');
    var price = card.querySelector('[data-zr-builder-price]');
    var placeholder = card.querySelector('[data-zr-art-placeholder]');
    if (placeholder) placeholder.hidden = Boolean(option && option.dataset.image);
    if (price && option) price.textContent = option.dataset.price || '';
    if (option) card.querySelectorAll('a').forEach(function (link) {
      var url = new URL(link.href, window.location.href);
      url.searchParams.set('variant', option.value); link.href = url.pathname + url.search;
    }); 
    if (option && option.dataset.image) {
      if (!image) {
        image = document.createElement('img');
        image.alt = card.querySelector('h2').textContent;
        image.loading = 'lazy';
        card.querySelector('.zr-builder-card__art').appendChild(image);
      }
      image.hidden = false;
      image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = option.dataset.image;
    } else if (image) {
      image.hidden = true;
    }
  }
  function replaceCart(html) {
    if (typeof html !== 'string') return false;
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-zr-builder-cart]');
    var current = root.querySelector('[data-zr-builder-cart]');
    if (!next || !current) return false;
    var selection = current.querySelector('[data-zr-builder-selection]');
    var scroll = current.querySelector('.zr-builder__items');
    var nextSelection = next.querySelector('[data-zr-builder-selection]');
    if (selection && nextSelection) nextSelection.open = selection.open;
    var scrollTop = scroll ? scroll.scrollTop : 0;
    current.replaceWith(next);
    root.dispatchEvent(new CustomEvent('zr:cart-rendered'));
    var nextScroll = next.querySelector('.zr-builder__items');
    if (nextScroll) nextScroll.scrollTop = scrollTop;
    controls();
    return true;
  }
  async function refreshCart() {
    var url = new URL(window.location.href);
    url.searchParams.delete('sections');
    url.searchParams.set('section_id', 'zr-builder-cart');
    var response = await request(url.pathname + url.search, {cache: 'no-store'});
    if (!response.ok || !replaceCart(await response.text())) throw new Error('Unable to refresh your cart.');
  }
  function notifyCart() { document.dispatchEvent(new CustomEvent('cart:build')); }
  async function mutate(path, data, successMessage, source) {
    if (busy || uncertain) return;
    var trayFocused = source && source.closest('[data-zr-builder-line]');
    busy = true; controls(); feedback('Updating your bundle…', true);
    try {
      data.sections = ['zr-builder-cart'];
      data.sections_url = contextPath();
      var response = await request(route(path), {method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(data)});
      var result = await response.json().catch(function () { return {}; });
      // Shopify can partially change a cart even when an inventory request returns 422.
      // Always reconcile with its actual cart; never retry a write automatically.
      if (!response.ok) {
        await refreshCart();
        uncertain = false;
        feedback((typeof result.description === 'string' ? result.description : (response.status === 422 ? 'That quantity is unavailable.' : 'That change could not be completed.')) + ' Your latest cart is shown.', true);
      } else {
        if (!replaceCart(result.sections && result.sections['zr-builder-cart'])) await refreshCart();
        uncertain = false;
        feedback(successMessage, false);
      }
      notifyCart();
    } catch (error) {
      try {
        await refreshCart();
        uncertain = false;
        feedback('We could not confirm that change. Your latest cart is shown; check it before adding again.', true);
        notifyCart();
      } catch (refreshError) {
        uncertain = true;
        feedback('We could not refresh your cart. Open your cart to check your order, or refresh here before making another change.', true);
      }
    } finally {
      busy = false; controls();
      if (trayFocused) {
        var summary = root.querySelector('[data-zr-builder-selection] summary');
        if (summary) summary.focus({preventScroll: true});
      }
      if (pendingRefresh) { pendingRefresh = false; refreshOnly(); }
    }
  }
  async function refreshOnly() {
    if (busy) { pendingRefresh = true; return; }
    busy = true; controls();
    try { await refreshCart(); uncertain = false; feedback('', false); }
    catch (error) { uncertain = true; feedback('Your cart could not be refreshed. Open your cart, or try refreshing again.', true); }
    finally { busy = false; controls(); }
  }
  function changeQuantity(line, quantity, source) {
    if (!line || !Number.isSafeInteger(quantity) || quantity < 0) {
      feedback('Enter a whole-number quantity of 0 or more.', true); return;
    }
    mutate('cart/change.js', {id: line.dataset.key, quantity: quantity}, quantity === 0 ? 'Print removed from your bundle.' : 'Bundle quantity updated.', source);
  }
  function init() {
    root = document.querySelector('[data-zr-builder]');
    if (!root || !root.querySelector('[data-zr-builder-cart]')) return;
    root.querySelectorAll('[data-zr-builder-variant]').forEach(syncArtwork);
    var selection = root.querySelector('[data-zr-builder-selection]');
    if (selection) selection.open = window.matchMedia('(min-width: 901px)').matches;
    root.querySelectorAll('[data-zr-builder-page]').forEach(function (a) {
      var url = new URL(a.href, window.location.href);
      url.searchParams.set('view', 'bundle-builder');
      a.href = url.pathname + url.search;
    });
    root.addEventListener('zr:catalog-rendered', controls);
    root.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches('[data-zr-builder-add]')) return;
      event.preventDefault(); event.stopPropagation();
      var id = form.querySelector('[name="id"]').value;
      if (id) mutate('cart/add.js', {items:[{id: id, quantity: 1}]}, 'Print added to your bundle.', form);
    });
    root.addEventListener('click', function (event) {
      var target = event.target;
      if (busy && target.closest('a')) { event.preventDefault(); return; }
      if (target.closest('[data-zr-builder-retry]')) { refreshOnly(); return; }
      if (target.closest('[data-zr-builder-show-tray]')) {
        var details = root.querySelector('[data-zr-builder-selection]');
        details.open = true;
        root.querySelector('.zr-builder__tray').scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        details.querySelector('summary').focus({preventScroll: true}); return;
      }
      var remove = target.closest('[data-zr-builder-remove]');
      if (remove) { changeQuantity(remove.closest('[data-zr-builder-line]'), 0, remove); return; }
      var button = target.closest('[data-zr-builder-delta]');
      if (button) {
        var line = button.closest('[data-zr-builder-line]');
        var number = Number(line.querySelector('[data-zr-builder-quantity]').value);
        changeQuantity(line, Math.max(0, number + Number(button.dataset.zrBuilderDelta)), button);
      }
    });
    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target.matches('[data-zr-builder-variant]')) syncArtwork(target);
      if (target.matches('[data-zr-builder-sort]') && !busy) target.form.submit();
      if (target.matches('[data-zr-builder-quantity]')) {
        if (target.value.trim() === '') { feedback('Enter a quantity before continuing.', true); return; }
        changeQuantity(target.closest('[data-zr-builder-line]'), Number(target.value), target);
      }
    });
    root.addEventListener('input', function (event) {
      if (event.target.matches('[data-zr-builder-quantity]')) event.target.style.setProperty('--zr-digits', Math.max(2, event.target.value.length));
    });
    document.addEventListener('cart:updated', refreshOnly);
    document.addEventListener('ajaxProduct:added', refreshOnly);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshOnly(); });
    window.addEventListener('pageshow', function (event) { if (event.persisted) refreshOnly(); });
  }
  document.addEventListener('DOMContentLoaded', init);
}());
